import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { SalesScheduleComponent } from './sales-schedule.component';


const routes: Routes = [
  {
      path: '',
      component: SalesScheduleComponent,
      canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesScheduleRoutingModule { }
